import Vue from 'vue';
import App from './Index.vue';
import OlEnv from './plugins/OlEnv';

Vue.use(OlEnv, {DEBUG: false});

new Vue({
  el: '#booking-organized-groups',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js